/**
 * Platform-neutral byte/base64/utf8 helpers (btoa/atob + TextEncoder, present in Node 20+ and browsers).
 * SHARED by the MCP server and the web client (`@shared/encoding`) so both sides encode identically — the
 * one source of truth for the wire encodings, no per-platform copies to drift.
 */
const encoder = new TextEncoder();
const decoder = new TextDecoder();

export function utf8ToBytes(s: string): Uint8Array {
  return encoder.encode(s);
}
export function bytesToUtf8(b: Uint8Array): string {
  return decoder.decode(b);
}

function binToBytes(bin: string): Uint8Array {
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
}
function bytesToBin(bytes: Uint8Array): string {
  let bin = "";
  for (const b of bytes) bin += String.fromCharCode(b);
  return bin;
}

/** Standard base64 (with padding) — the crypto wire format. */
export function bytesToB64(bytes: Uint8Array): string {
  return btoa(bytesToBin(bytes));
}
export function b64ToBytes(b64: string): Uint8Array {
  return binToBytes(atob(b64));
}

/** URL-safe base64 (no padding) — the compact `cc1:` pairing payload. */
export function bytesToB64url(bytes: Uint8Array): string {
  return bytesToB64(bytes).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
export function b64urlToBytes(s: string): Uint8Array {
  return b64ToBytes(s.replace(/-/g, "+").replace(/_/g, "/") + "=".repeat((4 - (s.length % 4)) % 4));
}
